"use strict";

exports.__esModule = true;
exports.UserRoutes = UserRoutes;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _System = require("../../../System");
var _UsersScreen = require("../UsersScreen");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * User Route
 */

function UserRoutes() {
  return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Routes, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: (0, _System.getScreenPath)("UserList") + "/*",
    element: /*#__PURE__*/_react["default"].createElement(_UsersScreen.UsersScreen, null)
  }));
}